/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectComponentsWithCategories } from "data/store/reducers/component";

const useComponentsWithCategories = () => {
    
    const componentConfigs = useSelector(selectComponentsWithCategories);

    // return componentsWithCategories 
    return useMemo(() => {
        const components = componentConfigs.reduce((acc, item) => {
            if (!acc[item.guid]) {
                acc[item.guid] = {
                    ...item,
                    categories: [item.category_name]
                };
            } else {
                if (!acc[item.guid].categories.includes(item.category_name)) {
                    acc[item.guid].categories.push(item.category_name);
                }
            }
            return acc;
        }, {});

        return Object.values(components);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, componentConfigs);
    
};

export { useComponentsWithCategories };
